define('instrumentation/ariaApplicationLogListener', [
    'lib/jquery',
    'lib/underscore',
    'instrumentation/log-level',
    'instrumentation/log-category',
    'instrumentation/ariaApplicationLogFormatter',
    'instrumentation/logs-queue-shim-local-storage',
    'PageContext',
    'lib/@aria/webjs-sdk',
], function ($, _, LOGLEVEL, LOGCATEGORY, ariaApplicationLogFormatter, LogQueue, pageContext, ariaSDK) {
    var ignoredApis = ['http://help', 'https://help', 'g.bing.com/clientsdk', 'api/updates/get'];

    var logTableNames = {};
    logTableNames[LOGCATEGORY.ERROR] = { name: 'ccuierr', priority: 1 };
    logTableNames[LOGCATEGORY.PERFORMANCE] = { name: 'ccuiperf', priority: 2 };
    logTableNames[LOGCATEGORY.CLICKEVENT] = { name: 'ccuiclickevent', priority: 3 };
    logTableNames[LOGCATEGORY.INPUTCHANGEEVENT] = { name: 'ccuiinputevent', priority: 3 };
    logTableNames[LOGCATEGORY.KEYBOARDEVENT] = { name: 'ccuikeyboardevent', priority: 3 };
    logTableNames[LOGCATEGORY.ROUTECHANGEEVENT] = { name: 'ccuipageevent', priority: 3 };
    logTableNames[LOGCATEGORY.TRACE] = { name: 'ccuitrace', priority: 4 };

    return function AriaApplicationLogListener(options) {
        var listener = this;
        var ariaLogger;
        var logs = new LogQueue({useLocalStorage: pageContext.FeaturePilotFlag && pageContext.FeaturePilotFlag.isClientSideLogsUseLocalStorageEnabled});
        var configuration;

        options = _.defaults({}, options, {
            applicationSystem: '',
            applicationLogLevel: '',
            flushInterval: 2000,
            batchSize: 25,
            constants: {
                IMPACTUSER: { True: true, False: false, NA: null },
            },
        });

        if (!pageContext.ariaToken) {
            _.extend(listener, {
                flushLogs: function (callback) {
                  executeCallback(callback);
                },
                write: _.noop,
                shouldLog: _.constant(false),
            });
        } else {
            options = _.defaults(options, {
                tenantToken: pageContext.ariaToken,
            });

            configuration = { enableAutoUserSession: true };
            ariaSDK.AWTLogManager.initialize(options.tenantToken, configuration);
            ariaLogger = new ariaSDK.AWTLogger();

            // log the information when initializing local storage
            if (!_.isEmpty(logs.initializingMessages)) {
                _.each(logs.initializingMessages, function (message) {
                    logs.push({
                        name: LOGCATEGORY.TRACE,
                        properties: {
                            value: {
                                Mes: message,
                            },
                        },
                    });
                });
            }

            $(window).on('beforeunload', function () {
                flush(true);
            });

            window.setInterval(function () {
                flush(false);
            }, options.flushInterval);

            _.extend(listener, {
                flushLogs: function (callback) {
                    flush(true, callback);
                },
                shouldLog: function (logMessage) {
                    return isErrorLog() || (!isLogLevelExcluded() && !isLogForIgnoredApi());

                    function isErrorLog() {
                        return _.contains(logMessage.logCategory, LOGCATEGORY.ERROR) || logMessage.logCategory === LOGCATEGORY.ERROR;
                    }

                    function isLogLevelExcluded() {
                        var actualListenerLogLevel = Math.min(options.applicationLogLevel.value, LOGLEVEL.DEBUG.value);
                        return logMessage.logLevel && logMessage.logLevel.value > actualListenerLogLevel;
                    }

                    function isLogForIgnoredApi() {
                        return _.isString(logMessage.api) && _.some(ignoredApis, function (ignoredApi) {
                            return logMessage.api.toLowerCase().indexOf(ignoredApi) > -1;
                        });
                    }
                },
                write: function(logMessage) {
                    var categoryName;
                    var formattedMessage;

                    if (listener.shouldLog(logMessage)) {
                        categoryName = getLogCategoryName(logMessage);
                        formattedMessage = ariaApplicationLogFormatter.formatLog(logMessage, options);
                        logs.push({
                            name: logTableNames[categoryName].name,
                            properties: getLogProperties(formattedMessage),
                        });
                    }
                },
            });
        }

        function executeCallback(callback) {
            var _callback = _.isFunction(callback) ? callback : _.noop;
            _callback();
        }

        function flush(ignoreBatchSize, callback) {
            var batchSize, logsToFlush;
            if (logs.size()) {
                /*eslint-disable-next-line no-extra-parens*/
                batchSize = (ignoreBatchSize || logs.size() < options.batchSize) ? logs.size() : options.batchSize;
                logsToFlush = logs.popMany(batchSize);

                if (window.BINGADS_DEBUG) {
                    window.console.log('Flush logs...ignoreBatchSize=' + ignoreBatchSize + ', batchSize=' + batchSize + ', actualSize=' + logsToFlush.length);
                }

                _.each(logsToFlush, _.bind(ariaLogger.logEvent, ariaLogger));
            }
            executeCallback(callback);
        }

        function getLogProperties(logMessage) {
            return _.mapObject(logMessage, function(val){
                return {
                    value: val,
                };
            });
        };

        function getLogCategoryName(logMessage) {
            var logCategory = logMessage.logCategory;
            var categoryName;

            if (_.isString(logCategory) && _.has(logTableNames, logCategory)) {
                categoryName = logCategory;
            } else if (_.isArray(logCategory) && logCategory.length > 0) {
                categoryName = _.min(
                    logCategory,
                    function (category) {
                        if (_.has(logTableNames, category)) {
                            return logTableNames[category].priority;
                        }

                        //Catch instances of people using invalid log category names
                        logs.push({
                            name: LOGCATEGORY.ERROR,
                            properties: {
                                value: {
                                    Mes: 'Invalid log category of ' + category,
                                },
                            },
                        });

                        return -1;
                    });
            }

            if (_.isUndefined(categoryName) || !_.has(logTableNames, categoryName)) {
                categoryName = _.max(
                    _.keys(logTableNames),
                    function (category) {
                        return logTableNames[category].priority;
                    });
            }

            return categoryName;
        }
    };
});